<template>
    <layout-admin class="">
        <div slot="sidebar" class="">

            <b-navbar class="px-0 pt-3 px-3" type="light"  variant="light" style="margin: 0 -15px;min-height: 67px; ">
                <b-navbar-brand href="#"></b-navbar-brand>
                <div class="text-left">
                    <small class="d-block">{{ clock |  moment("jYYYY/jMM/jDD") }}</small>
                    <small class="d-block">{{ clock | moment("HH:mm:ss") }} <i style="margin: 0 -1px" class="fa  fa-clock-o  fa-fw" aria-hidden="true"/></small>
                </div>
            </b-navbar>
            <b-alert class="rounded-0 mb-0 text-center mt-3" variant="light" show>
                هیچ پیامی برای نمایش یافت نشد
            </b-alert>
        </div>
        <div slot="content">
            <viewchart></viewchart>
        </div>
    </layout-admin>
</template>

<script>


    import MainLayout from "../layouts/MainLayout";
    import Viewchart from "../charts/Viewchart";
    import LayoutAdmin from "../layouts/LayoutAdmin";

    export default {
        components: {
            LayoutAdmin,
            Viewchart,
            MainLayout
        },
        name: "PageDashboard",
        metaInfo: {
            title: 'داشبورد',
        },
        computed: {},
        data() {
            return {
                clock: new Date()
            }
        },
        methods: {},
        created() {
            setInterval(() => {
              //  console.log('update time');
                this.clock = new Date()
            }, 1000);

        }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/PageDashboard.vue